/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'faction/ark-small': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M2 6.046v18.996l6-8.243V6.046zM9 25.042l7-9.892V7.292l-7 9.892zM17 25.042L31 6.046h-6.865L17 15.535zM9 15.15l6.521-9.104H9zM17 13.502l5.666-7.456H17z"/>'
  }
})
